import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logout, getUser } from './../actions';
import { LoadMore } from './../../ui/src/component/loadMore';
import { StandardArticleCustom } from './../component/standardArticleCustom';
import { fetchArticles } from './../../ui/src/csm.service.js';
import { Spinner } from './../../ui/src/component/spinner';
import Helmet from 'react-helmet';
import Api from './../../ui/src/api.js';
import { getProp } from '../../ui/src/utilities';
import Cookies from 'js-cookie';
import moment from 'moment';

class MyZone extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      articles: [],
      articlesNextOffset: null,
      articlesFetching: false,
    };
  }

  componentDidMount() {
    this.loadArticles(this.isLoggedIn(this.props), 8, 0);
  }

  isLoggedIn(props) {
    return props.user ? true : false;
  }

  componentWillReceiveProps(nextProps) {
    if (getProp(nextProps.user, 'id') !== getProp(this.props.user, 'id')) {
      this.loadArticles(this.isLoggedIn(nextProps), 8, 0);
    }
  }

  onClickMore() {
    this.loadArticles(
      this.isLoggedIn(this.props),
      8,
      this.state.articlesNextOffset
    );
  }

  loadArticles(loggedIn, limit, offset) {
    this.setState({ articlesFetching: true });
    let promise;
    if (loggedIn) {
      promise = Api.get(
        `/cm/public/${process.env.REACT_APP_CONTENT_SPACE}/userfeed`,
        {
          limit,
          offset,
        },
      );
    } else {
      promise = fetchArticles(process.env.REACT_APP_CONTENT_SPACE, {
        limit,
        offset,
      });
    }
    promise
      .then(response => {
        if (loggedIn) {
          Cookies.set('last_visit', moment().toISOString());
          this.props.dispatch(getUser());
        }
        this.setState({
          articles:
            offset === 0
              ? response.articles
              : [...this.state.articles, ...response.articles],
          articlesNextOffset: response.nextOffset,
          articlesFetching: false,
        });
      })
      .catch(err => {
        this.setState({ articlesFetching: false });
      });
  }

  render() {

    if (typeof window !== 'undefined') {
      let redirectUri = window.location.href;
      let authUri = `https://www.tvkosice.sk/api/oauth2/authorize?client_id=kosiceonline&redirect_uri=${encodeURIComponent(
        redirectUri,
      )}&response_type=token`;


      if (this.props.user) {
        return (
          <div>
            <Helmet title={'Články pre mňa'} />

            <div className="bg-alt-light article-header">
              <div className="container">
                <div className="article-header-title">
                  <h1>
                    Články pre mňa{' '}
                    <span
                      onClick={() => this.props.dispatch(logout())}
                      className="pull-right btn btn-primary"
                      style={{
                        position: 'relative',
                        top: '3px',
                      }}
                    >
                      <strong>Odhlásiť</strong>
                    </span>
                  </h1>
                </div>
              </div>
            </div>

            <Spinner show={this.state.articlesFetching}>
              <div className="container">
                <div className="section">
                  <div className="row">
                    {this.state.articles.map(item => {
                      return (
                        <div key={item._id} className="col-sm-6 col-md-3">
                          <StandardArticleCustom article={item} />
                        </div>
                      );
                    })}
                  </div>
                  {this.state.articlesNextOffset !== null && (
                    <div className="text-center">
                      <LoadMore
                        show={true}
                        onClick={this.onClickMore.bind(this)}
                      />
                    </div>
                  )}
                </div>
              </div>
            </Spinner>
          </div>
        );
      } else {

        return (
          <div>
            <Helmet title={'Prihláste sa'} />

            <div className="bg-alt-light article-header">
              <div className="container">
                <div className="article-header-title text-center">
                  <h2>
                    Prihláste sa a získate prístup k článkom, ktoré Vás zaujímajú
                </h2>
                  <a href={authUri} className="btn btn-primary">
                    Prihlásiť sa
                </a>
                </div>
              </div>
            </div>

            <Spinner show={this.state.articlesFetching}>
              <div className="container">
                <div className="section">
                  <div className="row flex-row">
                    {this.state.articles.map(item => {
                      return (
                        <div
                          key={item._id}
                          className="flex-col col-xs-12 col-sm-6 col-md-3"
                        >
                          <StandardArticleCustom article={item} />
                        </div>
                      );
                    })}
                  </div>
                  {this.state.articlesNextOffset !== null && (
                    <div className="text-center">
                      <LoadMore
                        show={true}
                        onClick={this.onClickMore.bind(this)}
                      />
                    </div>
                  )}
                </div>
              </div>
            </Spinner>
          </div>
        );
      }
    }
    return null;
  }
}

MyZone.propTypes = {
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.object,
};

const mapStateToProps = state => {
  return {
    user: state.loggedUser.user,
  };
};

export default connect(mapStateToProps)(MyZone);



// WEBPACK FOOTER //
// ./src/app/container/myZone.js